<template>
    <div class="fill-height">
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-card class="elevation-12" outlined width="500" rounded="lg">
                    <v-toolbar v-if="!isSecretHashActive" flat color="primary" height="32px"></v-toolbar>
                    <v-card-title class="justify-center">
                        <span class="primary--text">{{ $t('Создание пароля') }}</span>
                    </v-card-title>
                    <v-card-text v-if="isSecretHashActive" class="pb-0">
                        <v-form ref="updatePasswordForm">
                            <v-text-field
                                outlined
                                prepend-inner-icon="account_circle"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                v-model="password"
                                :rules="passwordRequirments"
                                :label="$t('Пароль')"
                                validate-on-blur
                            ></v-text-field>

                            <v-text-field
                                outlined
                                prepend-inner-icon="account_circle"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                v-model="passwordRepeated"
                                :rules="[passwordConfirmationRule]"
                                :label="$t('Повторите пароль')"
                                validate-on-blur
                            ></v-text-field>
                            <span v-if="innerMessage" style="font-size: 14px" class="red--text">{{ $t(innerMessage) }}</span>
                        </v-form>
                        <v-btn color="primary" height="50px" class="block mt-5" @click="savePassword">{{ $t('Сохранить') }}</v-btn>
                    </v-card-text>

                    <v-card-text v-else class="pb-0 gray--text text" style="margin-bottom:20px;font-size:15px">
                        <center>{{ $t(message) }}</center>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                    </v-card-actions>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import FormValidator from '@/mixins/FormValidator';

export default {
    data: () => ({
        password: null,
        passwordRepeated: null,
        showPassword: false,
        secretHash: null,
        isSecretHashActive: false,
        message: null,
        innerMessage: null
    }),
    mixins: [FormValidator],
    computed: {
        passwordConfirmationRule() {
            return () => this.password === this.passwordRepeated || this.$t('Введенные значения паролей не совпадают');
        }
    },
    async mounted() {
        let responseLogout = await this.logout({ nonHome: true });
        this.secretHash = this.$route.query.secret;
        let response = await this.isSecretHashExists(this.secretHash);
        if (response.data.isExists && !response.data.isSecretHashValid) {
            this.isSecretHashActive = false;
            this.message = 'Срок действия данной ссылки истек. Нажмите «Восстановить пароль» для получения новой ссылки.';
            return;
        }
        this.isSecretHashActive = response.data.isExists;
        this.message = 'Ссылка устарела или была использована ранее';

        this.$watch(
            '$i18n.locale',
            (newLocale, oldLocale) => {
                if (newLocale === oldLocale) {
                    return;
                }
                if (this.$refs.updatePasswordForm) {
                    this.$refs.updatePasswordForm.resetValidation();
                }
            },
            { immediate: true }
        );
    },
    methods: {
        ...mapActions('auth', ['isSecretHashExists', 'updatePassword', 'logout']),
        async savePassword() {
            if (!this.$refs.updatePasswordForm.validate()) return;
            this.innerMessage = null;
            let result = await this.updatePassword({ secretHash: this.secretHash, password: this.password });

            switch (result.message) {
                case 'NewPasswordSuccessfullySet':
                    this.isSecretHashActive = false;
                    this.message = 'Пароль успешно обновлен. Вы будете перенаправлены на страницу входа';
                    setTimeout(() => {
                        this.$router.push({ name: 'Signin' });
                    }, 3500);
                    break;
                case 'LinkLifetimeExpired':
                    this.isSecretHashActive = false;
                    this.message = 'Ссылка устарела или была использована ранее';
                    break;
                case 'NewPasswordEqualToOldPassword':
                    this.innerMessage = 'Новый пароль должен отличаться не менее чем на один символ';
                    break;

                default:
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.v-card {
    &__title {
        span {
            font: {
                weight: 700;
                size: 19px;
            }
            color: #6b7bb2;
        }
        margin: 0.3em;
    }
    &__text {
        center {
            font-weight: 400;
            font: {
                weight: 400;
                size: 14px;
            }
        }
    }

    .text {
        $width: 70%;
        width: $width;
        margin-left: (100% - $width) / 2;
    }
}
</style>
